// This app has no client-side router (plain server-rendered pages, see Sidebar.js/TopMenu.js), so
// a notification's target_route -- a logical name chosen by the backend presenter, not a URL -- is
// resolved to an actual page here rather than through any shared routing table.
const TARGET_ROUTE_MAP = {
    domains: '/domains/',
    invoices: '/customers/licenses/',
    'change-plan': '/customers/change_plan/',
};

export const resolveNotificationDestination = (notification) =>
    notification.target_url || TARGET_ROUTE_MAP[notification.target_route] || null;
